export default {
    "channels": {
		"title": "Channels",
		"sidebar": {
			"titles": "Channels",
			"title": "Channel"
		},
		"model": {
			"num": "Nº",
			"number": "Nº de Entrada",
			"data": "Data",
			"description": "Description",
			"provenance": "Provenance",
			"destiny": "Destiny",
			"coordinates": "Coordinates",
			"document_type": "Document Type",
			"file": "Files"
		},
		"error": {
			"load-data": "Failed to load data"
		}
    }
}